import { render, staticRenderFns } from "./ecologyService.vue?vue&type=template&id=28747bce&scoped=true&"
import script from "./ecologyService.vue?vue&type=script&lang=js&"
export * from "./ecologyService.vue?vue&type=script&lang=js&"
import style0 from "./ecologyService.vue?vue&type=style&index=0&id=28747bce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28747bce",
  null
  
)

export default component.exports